import { A as ACCOUNT_ORDERS, c as ACCOUNT_WISHLIST, d as ACCOUNT_SETTINGS, e as ACCOUNT_ADDRESSES, b as ACCOUNT_ORDER } from './paths-ZKN3m62_.js';

const ACCOUNT_MENU_ITEMS = [
    { name: 'orders', path: ACCOUNT_ORDERS },
    { name: 'wishlist', path: ACCOUNT_WISHLIST },
    { name: 'settings', path: ACCOUNT_SETTINGS },
    { name: 'addresses', path: ACCOUNT_ADDRESSES },
];
const ACCOUNT_TAB_ITEMS = [
    {
        title: 'orders',
        url: ACCOUNT_ORDERS,
        paths: [ACCOUNT_ORDERS, ACCOUNT_ORDER],
        iconClassName: 'icon-grid',
    },
    {
        title: 'wishlist',
        url: ACCOUNT_WISHLIST,
        paths: [ACCOUNT_WISHLIST],
        iconClassName: 'icon-heart',
    },
    {
        title: 'settings',
        url: ACCOUNT_SETTINGS,
        paths: [ACCOUNT_SETTINGS],
        iconClassName: 'icon-cog',
    },
    {
        title: 'addresses',
        url: ACCOUNT_ADDRESSES,
        paths: [ACCOUNT_ADDRESSES],
        iconClassName: 'icon-book2',
    },
];

export { ACCOUNT_TAB_ITEMS as A, ACCOUNT_MENU_ITEMS as a };
//# sourceMappingURL=account-o8FpsAAZ.js.map
